export default function numberFormat(number) {
  if (!number) {
    return null;
  }
  const num = parseFloat(number);
  if (isNaN(num)) {
    return null;
  }
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}



// WEBPACK FOOTER //
// ./src/services/general/numberFormat.js